import { useState } from 'react';
import axios from 'axios';
import { API } from '@/lib/axios';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FEEDBACK_REASONS, ONBOARDING_EVENTS } from '@/constants/onboardingConfig';

export default function FeedbackModal({ isOpen, onStay, onLeave, sessionId, trackEvent }) {
  const [selectedReason, setSelectedReason] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleLeave = async () => {
    setSubmitting(true);
    if (selectedReason) {
      trackEvent(ONBOARDING_EVENTS.FEEDBACK_SUBMITTED, {
        reason: selectedReason,
        has_text: !!feedbackText,
      });
      try {
        await axios.post(`${API}/onboarding/feedback`, {
          onboarding_session_id: sessionId,
          feedback_reason: selectedReason,
          feedback_text: feedbackText || null,
        });
      } catch {}
    }
    setSubmitting(false);
    onLeave();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onStay(); }}>
      <DialogContent className="bg-[#FDFBF7] dark:bg-[#22201C] border-[#E0D8CC] dark:border-[#2A2520] rounded-2xl max-w-sm mx-4">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl text-[#2A2420] dark:text-[#F0EBE4]">
            Before you go…
          </DialogTitle>
          <DialogDescription className="text-[#8C847A] dark:text-[#7C746A] text-sm">
            What almost stopped you from continuing?
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2 mt-2">
          {FEEDBACK_REASONS.map((reason) => (
            <button
              key={reason.id}
              onClick={() => setSelectedReason(reason.id === selectedReason ? null : reason.id)}
              className={`text-left px-4 py-2.5 rounded-xl text-sm border transition-all duration-200 ${
                selectedReason === reason.id
                  ? 'bg-[#5C4D6B]/8 dark:bg-[#B0A0C0]/10 border-[#5C4D6B]/30 dark:border-[#B0A0C0]/30 text-[#5C4D6B] dark:text-[#B0A0C0]'
                  : 'border-[#E8E0D4] dark:border-[#2A2520] text-[#4A4440] dark:text-[#C0BAB0] hover:border-[#5C4D6B]/30 dark:hover:border-[#B0A0C0]/30'
              }`}
            >
              {reason.label}
            </button>
          ))}
        </div>

        {selectedReason && (
          <textarea
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder="Anything you'd improve? (optional)"
            rows={2}
            className="mt-2 w-full resize-none rounded-xl border border-[#E0D8CC] dark:border-[#2A2520] bg-white/60 dark:bg-[#1A1816]/60 px-3 py-2 text-sm text-[#2A2420] dark:text-[#F0EBE4] placeholder-[#C4B8A8] dark:placeholder-[#4A4440] focus:outline-none focus:border-[#5C4D6B] dark:focus:border-[#B0A0C0] transition-colors"
          />
        )}

        <div className="flex flex-col gap-2 mt-1">
          <Button
            onClick={onStay}
            className="w-full bg-[#5C4D6B] hover:bg-[#4A3D58] dark:bg-[#7B6A90] text-white rounded-full py-5 font-medium"
          >
            Continue my story
          </Button>
          <Button
            onClick={handleLeave}
            disabled={submitting}
            variant="ghost"
            className="w-full text-[#A09890] dark:text-[#5C5650] hover:text-[#6B6560] rounded-full py-5 text-sm"
          >
            Leave anyway
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
